import React, { useEffect, useState } from "react";
import { Box, Button, Checkbox, Drawer, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

// Right-hand "Manage Columns" panel. `visible` is the current { key: bool } map; Apply hands
// back the edited copy, Reset asks the page to drop its saved choice.
const ColumnsDrawer = ({ open, onClose, columns, visible, onApply, onReset }) => {
  const [draft, setDraft] = useState(visible);
  useEffect(() => {
    if (open) setDraft(visible);
  }, [open]);

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: 320, borderTopLeftRadius: 12, borderBottomLeftRadius: 12, display: "flex", flexDirection: "column", height: '90%', top: '10%' } }}
    >
      <Box p={2} display="flex" justifyContent="space-between" alignItems="start">
        <Box>
          <Typography fontWeight={600} fontSize={16}>Manage Columns</Typography>
          <Typography fontWeight={400} fontSize={14} color="#7A7A7A">Your choice is saved for next time.</Typography>
        </Box>
        <IconButton onClick={onClose} sx={{ width: 32, height: 32 }}>
          <CloseIcon sx={{ fontSize: '18px' }} />
        </IconButton>
      </Box>

      <Box sx={{ flex: 1, overflowY: "auto", px: 2 }}>
        {columns.map((col) => (
          <Box
            key={col.key}
            onClick={() => !col.required && setDraft((prev) => ({ ...prev, [col.key]: !prev[col.key] }))}
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            sx={{ p: 1, borderRadius: 2, cursor: col.required ? "default" : "pointer", "&:hover": { backgroundColor: col.required ? "transparent" : "#F7F7F7" } }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Checkbox
                checked={!!draft[col.key]}
                disabled={col.required}
                size="small"
                sx={{ p: 0, color: "#C4C4C4", "&.Mui-checked": { color: "#BE1F1F" }, "&.Mui-checked.Mui-disabled": { color: "#8a8a8a" } }}
              />
              <Typography fontSize={14} sx={{ color: '#0A0A0A' }}>{col.label}</Typography>
            </Box>
            {col.required && (
              <Typography fontSize={12} sx={{ color: "#030213", backgroundColor: "#ECEEF2", px: 1.3, py: "2px", borderRadius: "8px" }}>
                Required
              </Typography>
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ p: 2, borderTop: "1px solid #eee", display: "flex", gap: 1 }}>
        <Button variant="outlined" fullWidth onClick={() => { onReset(); onClose(); }}
          sx={{ borderColor: "#BE1F1F", color: "#BE1F1F", "&:hover": { borderColor: "#ff4A4A", backgroundColor: "rgba(190,31,31,0.04)" } }}>
          Reset
        </Button>
        <Button variant="contained" fullWidth onClick={() => { onApply(draft); onClose(); }}
          sx={{ backgroundColor: "#BE1F1F", "&:hover": { backgroundColor: "#ff4A4A" } }}>
          Apply
        </Button>
      </Box>
    </Drawer>
  );
};

export default ColumnsDrawer;
